import { hideCaptchaBadge } from '../../../styles';
import * as React from 'react';
import { USERNAME } from '../../../constants/UrlParams';
import { fireNavigationEvent } from '../../../services/analytics';
import { LoginForm } from './LoginForm';
import { History } from 'history';
import { withLogin } from '../../hoc/Login/withLogin';
import { WrappedLoginComponentProps } from 'ts/login/hoc/Login/interfaces';
import { getHashOrQueryParam } from 'ts/window/WindowUtils';

hideCaptchaBadge();

const NAVIGATION_ERROR_EVENT = 'originenergy:for-home:my-account:login:error';
const NAVIGATION_EVENT = 'originenergy:for-home:my-account:login';

interface LoginComponentProps extends WrappedLoginComponentProps {
  className?: string;
  history: History;
  location: Location;
  username: string;
  setUsername: (username: string) => void;
  isUserNameCheckEnabled?: boolean; // should get rid of this since its always true
}

class LoginComponent extends React.Component<LoginComponentProps, {}> {
  public componentDidMount(): void {
    const aemError = getHashOrQueryParam('aem_error_message');
    const state = getHashOrQueryParam('state');
    const prepopulatedEmail = getHashOrQueryParam(USERNAME); // email passed from account found page
    if (prepopulatedEmail) {
      this.props.setUsername(prepopulatedEmail);
      this.props.checkForValidUser(prepopulatedEmail);
    }

    if (aemError) {
      this.props.handleError(aemError, state);
      fireNavigationEvent(NAVIGATION_ERROR_EVENT);
    } else {
      fireNavigationEvent(NAVIGATION_EVENT);
    }
  }

  public render() {
    const {
      checkingUser,
      disableUsernameIcon,
      error,
      loading,
      username,
      usernameError,
      password,
      passwordError,
      rememberMe,
      loginSubmit,
      handleUsernameOnChange,
      handleUsernameOnBlur,
      handlePasswordOnChange,
      handleRememberMeChange,
      isUserNameCheckEnabled,
    } = this.props;

    return (
      <LoginForm
        checkingUser={checkingUser}
        disableUsernameIcon={disableUsernameIcon}
        error={error}
        loading={loading}
        isUserNameCheckEnabled={isUserNameCheckEnabled}
        username={username}
        usernameError={usernameError}
        password={password}
        passwordError={passwordError}
        rememberMe={rememberMe}
        loginFormActions={{
          handleFormSubmit: loginSubmit,
          handleUsernameOnChange,
          handleUsernameOnBlur,
          handlePasswordOnChange,
          handleRememberMeChange,
        }}
      />
    );
  }
}

const LoginPage = withLogin(LoginComponent);

export { LoginPage };
